(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-info-section"] && !Shopify.designMode) return;
  try {
    $(document).ready(function () {
  
    function flipCard() {
      $('.circle-container').off('click').on('click', function (event) {
      
        if (!$(event.target).closest('.custom_button').length) {
          $(this).find('.circle-flip').toggleClass('flipped');
        }
      });
  
     
      $('.custom_button').off('click').on('click', function (event) {
        event.stopPropagation(); 
       
      });
    }
  
   
    function initAutoFlip() {
      function isInViewport(element) {
        const rect = element.getBoundingClientRect();
        return (
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
      }
  
      function handleAutoFlip() {
        $('.circle-container').each(function () {
          if (isInViewport(this)) {
            
            if (!$(this).hasClass('flipped-once')) {
               const $circle = $(this);
        // Add 1 second delay before flipping
        setTimeout(function() {
          $circle.find('.circle-flip').addClass('flipped');
          $circle.addClass('flipped-once');
        }, 1000);
            }
          } else {
            
            if ($(this).hasClass('flipped-once')) {
              $(this).find('.circle-flip').removeClass('flipped');
              $(this).removeClass('flipped-once');
            }
          }
        });
      }
  
      
      if (Shopify.designMode) {
        $('.circle-container').removeClass('flipped-once');
      }
  
      
      handleAutoFlip();
  
      
      $(window).scroll(function () {
        handleAutoFlip();
      });
    }
  
    
    flipCard();
    initAutoFlip();
  
    
    if (Shopify && Shopify.designMode) {
      $(document).on("shopify:section:load", function () {
        flipCard();
        initAutoFlip();
      });
    }
  });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-custom"]) return;
  try {
    
$(document).ready(function() {
  function toggleMenu() {
    $('.custom-footer-menu .menu-title').on('click', function() {
   
      $('.custom-footer-menu').not($(this).closest('.custom-footer-menu')).removeClass('active');
      
   
      $(this).closest('.custom-footer-menu').toggleClass('active');
    });
  }


  toggleMenu();

  if (Shopify && Shopify.designMode) {
    $(document).on('shopify:section:load', function() {
      toggleMenu();
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
